import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonPurpose } from './button-purpose';
import { ButtonType } from './button-type';
import * as i0 from "@angular/core";
const _c0 = ["*"];
/**
 * @deprecated since version 9.0
 */
export class ButtonComponent {
    constructor() {
        this.buttonText = '';
        this.enableLight = false;
        this.type = ButtonType.Button;
        this.disabled = false;
        this.purpose = ButtonPurpose.Primary;
        this.ariaExpanded = null;
    }
}
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(); };
ButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ButtonComponent, selectors: [["mhe-button"]], inputs: { buttonText: "buttonText", enableLight: "enableLight", type: "type", disabled: "disabled", purpose: "purpose", ariaExpanded: "ariaExpanded" }, ngContentSelectors: _c0, decls: 4, vars: 9, consts: [[3, "type", "disabled"], ["button", ""]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "button", 0, 1);
        i0.ɵɵtext(2);
        i0.ɵɵprojection(3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("btn ", ctx.purpose, "");
        i0.ɵɵclassProp("btn-secondary-light", ctx.enableLight);
        i0.ɵɵpropertyInterpolate("type", ctx.type);
        i0.ɵɵproperty("disabled", ctx.disabled);
        i0.ɵɵattribute("aria-expanded", ctx.ariaExpanded);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.buttonText, " ");
    } }, styles: ["[_nghost-%COMP%]{display:inline-block}[_nghost-%COMP%]   button[_ngcontent-%COMP%]{width:100%}\n"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{ selector: 'mhe-button', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button\n  #button\n  type=\"{{ type }}\"\n  class=\"btn {{ purpose }}\"\n  [class.btn-secondary-light]=\"enableLight\"\n  [disabled]=\"disabled\"\n  [attr.aria-expanded]=\"ariaExpanded\"\n>\n  {{ buttonText }}\n  <ng-content></ng-content>\n</button>\n", styles: [":host{display:inline-block}:host button{width:100%}/*# sourceMappingURL=button.component.css.map */\n"] }]
    }], null, { buttonText: [{
            type: Input
        }], enableLight: [{
            type: Input
        }], type: [{
            type: Input
        }], disabled: [{
            type: Input
        }], purpose: [{
            type: Input
        }], ariaExpanded: [{
            type: Input
        }] }); })();
